import ChannelCard from './ChannelCard';
import provideChannelData from '../../hoc/ProvideChannelData';

export default provideChannelData(ChannelCard);


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/ChannelCard/ChannelCradContainer.tsx